import Vuex, { StoreOptions } from 'vuex';

import API from '@/Api/api_data';
import Vue from 'vue';
import authMessage from './modules/auth';
import dosimu from '@/Api/api_simulaion';
import locationMessage from '@/store/modules/locationMessage';
import run_time from '../Utils/run_time';
import Weather from '@/store/modules/weather-data';
import Evaluate from '@/store/modules/evaluate';
import Project from '@/store/modules/project';
Vue.use(Vuex);

const runTime = new run_time();
const loadStepTime = 10;
const titleMap: Record<string, string> = {
    阶梯电价: '阶梯电价的结算周期为1个月',
    蒸汽按热量计价: '热量的计算方法为负荷处的蒸汽与对应压力下的饱和水之间的焓差',
    采暖用热按热量计价: '热量的计算方法为负荷进出口水之间的焓差',
    冷负荷中的按热量计价: '热量的计算方法为负荷进出口水之间的焓差',
    '年运营支出(万元)': '运维费用主要包括购买燃料和从公共电网购电两项费用',
    能效水平: '指实际用能占实际供能的比例（四种能源形式的平均值）',
    可再生能源利用比例: '指通过利用可再生能源生产的能量（电能、热能）在总供能（电能、热能）中的比例',
};
export default new Vuex.Store({
    state: {
        current_id: 0,
        isLoading: false,
        projects: {},
        taskId: '',
        running: false,
        runend: false,
        progress: 0,
        currentPlanId: 0,
        optimizationMode: 0,
        isStop: false,
        iesMode: false,
        navigationRecords: { data: '', diagram: '', scheme: '', evaluate: '', digitalTwins: '' },
        isMainOnLoading: false,
        stringFieldRules: [{ required: true, message: '该字段不能为空', trigger: 'blur' }],
        numberFieldRules: [
            { required: true, message: '该字段不能为空', trigger: 'blur' },
            //字段不能为function,此处标记为string绕过检查
            { type: 'string', message: '该字段只能为数字', transform: ((value) => String(value)) as unknown as string, pattern: /^-?\d*\.?\d+$/ },
        ],
        isTypicalLibraryEditMode: false,
        hotSettingsData: {} as Record<string, Array<Record<string, string>>>,
        studioIframe: null,
    },
    mutations: {
        setIsTypicalLibraryEditMode(state, value) {
            state.isTypicalLibraryEditMode = value;
        },
        setStudioIframe(state, value) {
            state.studioIframe = value;
        },
        setIESMode(state, value) {
            state.iesMode = value;
        },
        // 控制loading显示隐藏
        updateLoadingStatus(state, payload) {
            state.isLoading = payload.isLoading;
        },
        setCurrentId: (state: any, id: any) => {
            state.current_id = id;
        },
        setProjects: (state: any, projects: any) => {
            state.projects = projects;
        },
        setTaskId: (state: { taskId: string }, taskId: string) => {
            state.taskId = taskId;
        },
        setRunning: (state: { running: boolean }, running: boolean) => {
            state.running = running;
        },
        setRunend: (state: { runend: boolean }, runend: boolean) => {
            state.runend = runend;
        },
        setIsStop: (state: { isStop: boolean }, isStop: boolean) => {
            state.isStop = isStop;
        },
        setprogress: (state: { progress: number }, progress: number) => {
            state.progress = progress;
        },

        setCurrentPlanId: (state: { currentPlanId: number }, currentPlanId: number) => {
            state.currentPlanId = currentPlanId;
        },
        setOptimizationMode: (state: { optimizationMode: number }, optimizationMode: number) => {
            state.optimizationMode = optimizationMode;
        },
        newProject: (state: any, params: any) => {
            state.projects.push({
                id: state.projects.length,
                name: params.name,
                desc: params.desc,
                modifiedTime: params.modifiedTime,
                status: 0,
            });
        },

        setNavigationRecord: (state, payload: { key: string; value: string }) => {
            state.navigationRecords[payload.key] = payload.value;
        },
        setIsMainOnLoading: (state, payload: boolean) => {
            state.isMainOnLoading = payload;
        },
        sethotSettingsData: (state, payload: Record<string, Array<Record<string, string>>>) => {
            state.hotSettingsData = payload;
        },
    },
    actions: {
        getProjectListSyc(context, id) {
            return API.getSimuData({ id: id }).then((res: any) => {
                context.commit('setProjects', res);
                context.commit('setCurrentId', id);
                return res;
            });
        },
        loadLastSimulationTask(context, simuid) {
            return dosimu.getLastSimulationTask({ simuid: simuid }).then((ret: any) => {
                if (!ret.error) {
                    context.commit('setTaskId', ret.data.task_id);
                    context.commit('setOptimizationMode', ret.data.optimizationpara['OptimizationMode'] || 0);
                    if (ret.data.status == 'stop') {
                        context.commit('setIsStop', true);
                    }
                    return ret;
                } else if (ret.error == -1) {
                    context.commit('setRunning', false);

                    return ret;
                } else {
                    context.commit('setRunning', false);
                    return ret;
                }
            });
        },
        getSimulationLog(context, contData) {
            const taskid = context.state.taskId;
            const simuid = contData.simuid;
            const runningGet = () => {
                dosimu.getSimuLog({ simuid: simuid, taskid: taskid }).then((data: any) => {
                    const mag = data.msg;
                    for (let index = 0; index < mag.length; index++) {
                        const element = mag[index];
                        if (element.data == 'run start') {
                            context.commit('setRunning', true);
                        }
                        if (element.data == 'run ends') {
                            context.commit('setRunend', true);
                            context.commit('setRunning', false);
                            break;
                        }
                    }
                    if (context.state.isStop) {
                        if (contData.callback) {
                            contData.callback(false);
                        }
                        context.commit('setRunend', true);
                        context.commit('setRunning', false);
                        return;
                    }
                    if (context.state.runend) {
                        // this.getSimuResult()
                        // this.progress = 100;
                        if (contData.callback) {
                            contData.callback(false);
                        }
                        context.commit('setprogress', 100);
                    } else if (context.state.running) {
                        if (contData.callback) {
                            contData.callback(false);
                        }
                        // this.progress = Number((data.progress.data || 0).toFixed(2))
                        context.commit('setprogress', Number((data.progress.data || 0).toFixed(2)));
                        if (runTime) {
                            runTime._setTimeout(() => {
                                // this.getSimuLog();
                                if (!context.state.runend) {
                                    runningGet();
                                }
                            }, loadStepTime * 1000);
                        }
                    } else {
                        if (contData.callback) {
                            contData.callback(true);
                        }
                    }
                });
            };
            runningGet();
        },
        clearRunTime(context) {
            context.commit('setRunning', false);
            runTime._clearTimeTickers();
        },
    },
    getters: {
        getProcess: (state) => {
            return state.progress;
        },
        getTaskId: (state) => {
            return state.taskId;
        },
        getRunend: (state) => {
            return state.runend;
        },
        getRunning: (state) => {
            return state.running;
        },

        getOptimizationMode: (state) => {
            return state.optimizationMode;
        },

        getCurrentPlanId: (state) => {
            return state.currentPlanId;
        },
        getTitle: () => (name: string) => {
            return titleMap[name];
        },
        getNavigationRecords: (state) => {
            return state.navigationRecords;
        },
        getIsMainOnLoading: (state) => {
            return state.isMainOnLoading;
        },
        getHotSettingsData: (state) => {
            return state.hotSettingsData;
        },
    },
    modules: {
        Weather,
        locationMessage,
        Evaluate,
        authMessage,
        Project,
    },
} as unknown as StoreOptions<Record<string, any>>);
